export default __webpack_public_path__ + "static/media/flag-french-guiana.d72fa6b1.svg";